export default __webpack_public_path__ + "static/media/partner-business-vip.57f3e688.png";